<template>
  <div class="archive-explorer">
    <a @click="showModal" class="btn btn-xs btn-primary btn-outline"><i class="fa fa-file-archive-o"></i> View archive</a>

    <modal :id="modalId" title="Archive Content">

      <div class="text-center m-b-md">Current directory:<br><strong>{{currentDirLabel}}</strong></div>

      <div class="archive-explorer-content">
        <div v-for="item in currentDirItems">
          <a v-if="!item.isDir" @click="download(item)" href="#">{{item.label}}</a>
          <a v-else @click="changeCurrentDir(item.name)"><i class="fa fa-folder"></i> {{item.label}}</a>
        </div>
      </div>

      <template v-slot:footer>
        <button type="button" class="btn btn-white" @click="hideModal">Close</button>
      </template>

    </modal>
  </div>
</template>

<script>
import HasModal from "./mixins/HasModal";
export default {
  mixins: [HasModal],

  /**
   * Input properties.
   *
   * Usage examples:
   *
   * <archive-explorer modal-id="archive_explorer_{{$form->id}}"
   *                   :items="{{json_encode($form->getZipContent())}}">
   * </archive-explorer>
   */
  props: {

    // Modal dialog id.
    modalId: {
      type: String,
      default: 'archiveExplorerModal'
    },

    // Archived item list (files and folders metadata inside the archive).
    items: {
      type: Array,
      default: [],
    }

  },

  /**
   * Variables (models).
   */
  data() {
    return {
      // Current directory pointer inside the archive.
      currentDir: '',
    }
  },

  /**
   * Functions (methods).
   */
  methods: {

    /**
     * Opens file download location.
     */
    download(item) {
      window.open(item.downloadPath, '_blank');
    },

    /**
     * Changes current directory pointer.
     */
    changeCurrentDir(dir) {
      if (this.currentDir === dir) {
        this.currentDir = this.upperDir;
        return;
      }
      this.currentDir = dir;
    },

  },

  /**
   * Computed values
   */
  computed: {

    /**
     * Current directory level items.
     */
    currentDirItems() {
      return this.items
          // Get item basename and label.
          .map(item => {
            // Basename is just an item name without a path.
            item.basename = item.name.substring(this.currentDir.length);
            // Label is what is outputted to user as item name.
            item.label = item.basename;
            // Current directory will link to upper directory in list, so let use some special label for it.
            if (!item.basename.length && item.isDir) item.label = '[...]';
            // No need to show slash in the end of item name.
            if (item.label.substring(item.label.length - 1) === '/')
              item.label = item.label.substring(0, item.label.length - 1);
            return item;
          })
          // Filter current directory items only.
          .filter(item => {
            // Make sure item name starts from current directory name.
            if (item.name.substring(0, this.currentDir.length) !== this.currentDir) return false;
            // Return the subdirectory of current directory only.
            if (!item.isDir && !item.basename.includes('/')) return true;
            // Return the file of current directory only.
            if (item.isDir && !item.basename.substring(0, item.basename.length - 1).includes('/')) return true;
          })
          // Show directories first.
          .sort(function(a, b) {
            if (a.isDir && !b.isDir) return -1;
            if (!a.isDir && b.isDir) return 1;
            return 0;
          });
    },

    /**
     * Current directory label (upper dirs + current dir).
     */
    currentDirLabel() {
      return '[archive root]' + (this.currentDir.length ? '/' + this.currentDir : '');
    },

    /**
     * Directory one level upper from current.
     */
    upperDir() {
      if (!this.currentDir.length) return '';
      let subDirs = this.currentDir.split('/');
      if (subDirs.length) subDirs.splice(subDirs.length - 2, 2);
      subDirs.push('');
      return subDirs.join('/');
    },

  },

  /**
   * Component initialization.
   */
  mounted: function () {
  },
}
</script>

<style scoped>
.archive-explorer-content {
  font-size: 14pt;
}
</style>
